import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { CoreInput } from 'components/core/library/input';
import { CoreLabel } from 'components/core/library/label';

import './RadioInput.scss';

export default function RadioInput({
	className, checked, label, labelFor, onChange, value, name
}) {
	return (
		<CoreLabel
			className={classnames(className, 'radio-input')}
			text={label}
			htmlFor={labelFor || name}
			textClassName="radio"
			textAfterChildren
		>
			<CoreInput
				type="radio"
				className="radio"
				onChange={onChange}
				checked={checked}
				value={value}
				name={name}
			/>
		</CoreLabel>
	);
}

RadioInput.propTypes = {
	className: PropTypes.string,
	checked: PropTypes.bool,
	label: PropTypes.string,
	labelFor: PropTypes.string,
	name: PropTypes.string,
	onChange: PropTypes.func,
	value: PropTypes.string
};
